class MajorCountdown {
  constructor(element) {
    this.element = element;
    this.endDate = new Date(element.dataset.endDate).getTime();

    // Get references to all digit displays
    this.daysTens = element.querySelector('.days-tens span');
    this.daysOnes = element.querySelector('.days-ones span');
    this.hoursTens = element.querySelector('.hours-tens span');
    this.hoursOnes = element.querySelector('.hours-ones span');

    // Get optional minute and second displays
    const minutesContainer = element.querySelector('.minutes-container');
    const secondsContainer = element.querySelector('.seconds-container');
    if (minutesContainer) {
      this.minutesTens = minutesContainer.querySelector('.minutes-tens span');
      this.minutesOnes = minutesContainer.querySelector('.minutes-ones span');
    }
    if (secondsContainer) {
      this.secondsTens = secondsContainer.querySelector('.seconds-tens span');
      this.secondsOnes = secondsContainer.querySelector('.seconds-ones span');
    }
    this.updateTimer();
    setInterval(() => this.updateTimer(), 1000);
  }
  updateTimer() {
    const now = new Date().getTime();
    const distance = this.endDate - now;
    if (distance <= 0) {
      this.updateDigits(0, 0, 0, 0);
      return;
    }
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
    const seconds = Math.floor(distance % (1000 * 60) / 1000);
    this.updateDigits(days, hours, minutes, seconds);
  }
  updateDigits(days, hours, minutes, seconds) {
    // Update days
    const daysStr = String(days).padStart(2, '0');
    this.daysTens.textContent = daysStr[0];
    this.daysOnes.textContent = daysStr[1];

    // Update hours
    const hoursStr = String(hours).padStart(2, '0');
    this.hoursTens.textContent = hoursStr[0];
    this.hoursOnes.textContent = hoursStr[1];

    // Update minutes if they exist
    if (this.minutesTens && this.minutesOnes) {
      const minutesStr = String(minutes).padStart(2, '0');
      this.minutesTens.textContent = minutesStr[0];
      this.minutesOnes.textContent = minutesStr[1];
    }

    // Update seconds if they exist
    if (this.secondsTens && this.secondsOnes) {
      const secondsStr = String(seconds).padStart(2, '0');
      this.secondsTens.textContent = secondsStr[0];
      this.secondsOnes.textContent = secondsStr[1];
    }
  }
}
document.querySelectorAll('.flip-clock-wrapper').forEach(countdown => {
  new MajorCountdown(countdown);
});